import * as MType from './mutation-types'
import formData from './productFormJson.js'

export const mState = {
  isLoading: false,
  direction: 'forward', // 记录方向
  msg: '',              // 系统消息
  errorMsg: '',         // 错误消息
  scrollTop: 0,         // 滚动条距离顶部位置
  showTitle: '',
  tempData: null,
  // ===================================================== benon
  baseInfoForm: formData.basicInfoForm(),
  contentForm: formData.contentForm(),
  reserveSetForm: formData.reserveSetForm()
}

export const mMutations = {
  [MType.UPDATE_MSG] (state, msg) { state.msg = msg },
  [MType.UPDATE_ERROR_MSG] (state, msg) { state.errorMsg = msg },
  [MType.UPDATE_SCROLLTOP_POSITION] (state, payload) { state.scrollTop = payload.top },
  [MType.UPDATE_LOADING] (state, status) { state.isLoading = status },
  [MType.UPDATE_SHOW_TITLE] (state, title) { state.showTitle = title },
  [MType.UPDATE_DIRECTION] (state, direction) { state.direction = direction },
  setBaseInfoForm (state, form) { state.baseInfoForm = form },
  setContentForm (state, form) { state.contentForm = form },
  setReserveSetForm (state, form) { state.reserveSetForm = form },
  setPriceSetParams (state, params) {
    if (params.productId) state.priceSetParams.productId = params.productId
    if (params.productName) state.priceSetParams.productName = params.productName
    if (params.productSaleDate) state.priceSetParams.productSaleDate = params.productSaleDate
  }
}

export const mActions = {
  updateScrollPosition ({commit}, top) {
    commit({
      type: MType.UPDATE_SCROLLTOP_POSITION,
      top: top
    })
  }
}

export const mGetters = {
}



// WEBPACK FOOTER //
// ./src/vuex/store.js